// Module
var code = `<ex-multi-occurrence-maitre-details-ecran lbl-titre="LBL_TITRE" multi-occurrence-options="vm.multiOccurrenceOptions" multi-occurrence-out="vm.multiOccurrence"> </ex-multi-occurrence-maitre-details-ecran> `;
// Exports
module.exports = code;